import { render } from "./zhenggaoyixuejishu-news.vue?vue&type=template&id=19dfa441&scoped=true"
import script from "./zhenggaoyixuejishu-news.vue?vue&type=script&lang=js"
export * from "./zhenggaoyixuejishu-news.vue?vue&type=script&lang=js"

import "./zhenggaoyixuejishu-news.vue?vue&type=style&index=0&id=19dfa441&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dfa441"]])

export default __exports__